// extracted by mini-css-extract-plugin
export default {"container":"styles_container__K97oD","noGap":"styles_noGap__6a9OQ","container__card":"styles_container__card__s5R6v"};